module.exports = __webpack_public_path__ + "img/grey_008.ec5a6515.png";